import { useEffect, useState } from "react";
import introJs from "intro.js";
import "intro.js/introjs.css";
import { useNavigate } from "react-router-dom";
import {header_main, home_section_left, home_section_right, home_tab_one, rewards_button, upload_bill_icon} from '../Image/Index'
import ModalCard from "../components/layout/ModalCard";

const IntroChooseReward=()=>{


const intro=introJs()
let complete=false
let exitOnLast=false
const [show,setShow]=useState(false)
const navigate=useNavigate()
    useEffect(() => { 
      localStorage.setItem('firstLogin', 'customer')
        const handleLoad=()=>{ 
         const steps = [
            {
                element: document.getElementById('rewards'),
                title: 'Choose Rewards',
                intro: "Browse and select rewards that align with your interests and preferences. "
              },
          
              
             
         ]
         intro.setOptions({
             steps: steps,
            exitOnOverlayClick: false,
             doneLabel:"Next",
             tooltipClass: 'customTooltip'
           });
         intro.start();
         } 
         setTimeout(()=>{
            handleLoad()
         },500)
         return () => {
            intro.exit();
        }; 
        
       }, []);
       intro.oncomplete(function(element) {
        complete=true
        setTimeout(()=>{
            if(!exitOnLast) navigate("/intro/customer/deals")
        },700)


    });
    intro.onexit(() => {
        if(!complete) {
            localStorage.setItem('firstLogin','')  
           setShow(true)
            }
            
        
      });
      intro.onchange(function(element) {
        switch (this._currentStep){
            case 0:
              setTimeout(()=>{
                let cross=  document.getElementsByClassName("introjs-skipbutton")[0]
                cross?.addEventListener('click', function() {
                exitOnLast=true
                localStorage.setItem('firstLogin','')   
                setShow(true)  
                });
              },600)  
      
              
                   break;
                 
           }
      
      });
    return(<>
    {show && <ModalCard show={show} customer={true}/>}

    <div className="cj_home_one">
      <div className="cj_home_one_header">
        <img src={header_main} alt=""/>
      </div>
      <div className="cj_home_one_body">
        <div className="cj_home_one_body_left cj_home_one_body_left_with_button">
          <img src={home_section_left} alt=""/>
          <div className="rewards_button" id='rewards'>
            <img src={rewards_button}/>
          </div>
        </div>
        <div className="cj_home_one_body_right">
          <img src={home_section_right} alt=""/>
        </div>
      </div>
      <div className="cj_home_one_big_body">
        <img src={home_tab_one} alt=""/>
      </div>
    </div>
    
    {/* <img src={earn_reward_points} style={{"height":'400px'}} ></img>
    <img id='rewards' src={earn_reward_points}></img> */}
    
    </>)
}
export default IntroChooseReward